import React from "react";
import { Text, withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import moment from "moment";
import i18n from "i18next";
import { connect } from "react-redux";
import { api } from "@/utils/api";
import url from "@/utils/url";
import { tagTypeEnum, modeEnum } from "@/utils/enum";
import { isEmpty } from "@/utils/index";

class HeaderSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tags: [],
    };
  }

  componentDidMount() {
    this.getTags();
  }

  getTags = () => {
    const {
      sitecoreContext: {
        itemId: itemid,
        route: { fields, itemVersion },
      },
      scMode,
    } = this.props;
    const objValue = { itemid };
    const pageEditing = scMode === modeEnum.pageEditing;
    if (pageEditing) {
      objValue.version = itemVersion;
    }
    api[fields?.isLibrary?.value ? "library" : "report"]
      .getTags(objValue)
      .then((response) => {
        response && response.length > 0 && this.setState({ tags: response });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  tagClick = (item) => {
    const {
      router: {
        history: { push },
      },
    } = this.props;
    push({
      pathname:
        item.type === tagTypeEnum.report
          ? url.researchSearch
          : url.librarySearch,
      state: { selectTag: item.tcode },
    });
  };

  render() {
    const {
      sitecoreContext: {
        route: { fields },
      },
    } = this.props;
    const { tags } = this.state;
    const authorPosition = decodeURIComponent(
      fields?.authorAndPosition?.value || ""
    )
      .replace(/=/g, "／")
      .replace(/&/g, ",　");

    let image;
    let prefix;
    if (fields?.CreateDate?.value !== fields?.publicDate?.value) {
      image = "icon_update.png";
      prefix = `${i18n.t("Library_kbn_update")}：`;
    } else {
      image = "icon_publish.png";
      prefix = `${i18n.t("Library_kbn_publish")}：`;
    }

    return (
      <div className="header-section-container">
        <Text field={fields?.title} tag="div" className="title" />
        <div className="section-container">
          <div className="category-container">
            {fields?.isLibrary?.value ? (
              <React.Fragment>
                <img alt="" src={require(`@/assets/images/${image}`)} />
                <div className="public-date date-prefix">{prefix}</div>
              </React.Fragment>
            ) : null}
            <div className="public-date">
              {moment(fields?.publicDate?.value)
                .utcOffset(9)
                .format("yyyy.MM.DD")}
            </div>
            {tags.length > 0
              ? tags.map(
                  (item, index) =>
                    !isEmpty(item.text) && (
                      <div
                        className="category"
                        key={index}
                        onClick={() => this.tagClick(item)}
                        tabIndex="0"
                      >
                        {item.text}
                      </div>
                    )
                )
              : null}
          </div>
          <div className="author-position-area">{authorPosition}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    scMode: state?.config?.mode,
  };
};

export default connect(mapStateToProps)(withSitecoreContext()(HeaderSection));
